import { styled } from 'design'

export const Badge = styled('div', {
  display: 'inline-flex',
  flex: 'none',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '$space$5',
  fontSize: '13px',
  textAlign: 'center',
  lineHeight: 1.5,
  color: 'white',
  background: '$red500',
  borderRadius: '$5',
  padding: '0 $1',
})

Badge.defaultProps = {
  className: 'topic__badge',
}

export type BadgeProps = React.ComponentProps<typeof Badge>
